import React from 'react';

import styles from './troy.module.scss';
import { Grid } from '../../components/common';
import { connectTo } from '../../utils';

import { LoginForm, Welcome } from '../../components/login/index.troy';

import { login } from '../../actions';

class LoginPage extends React.Component {
  onLogin = (values) => {
    const { login } = this.props;
    login(values);
  };

  render() {
    return (
      <div className={styles['login-page__wrapper']}>
        <div className={styles['login-page__content']}>
          <Grid item md={9} className={styles['login-page__welcome-wrapper']}>
            <Welcome />
          </Grid>
          <Grid item md={3}>
            <LoginForm onSubmit={this.onLogin} />
          </Grid>
        </div>
      </div>
    );
  }
}

export default connectTo(() => ({}), { login }, LoginPage);
